import React,{useEffect} from "react";
import ReactDOM from "react-dom";
import "./modal.css";

export default function Modal({ show, onClose, children }) {
  
  useEffect(() => {
    const handleEscape = (e) => {
      if (e.key === "Escape") onClose();
    };
    
    if (show) {
      document.addEventListener("keydown", handleEscape);
      document.body.style.overflow = "hidden"; 
    }
    
    return () => {
      document.removeEventListener("keydown", handleEscape);
      document.body.style.overflow = "unset";
    };
  }, [show, onClose]);
if (!show) return null;

  const handleBackdropClick = (e) => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  return ReactDOM.createPortal(
    <div className="modal-overlay" onClick={handleBackdropClick}>
      <div className="modal-content">
        <button 
          className="modal-close-btn" 
          onClick={onClose}
          aria-label="Close modal"
          type="button"
        >
          ✖
        </button>
        <div className="modal-body">
          {children}
        </div>
      </div>
    </div>,
    document.body
  );
}
